/* Selector file rule: root-level functions in this file must be exported selectors only. Move helper functions to lib files. */
import { createSelector } from 'reselect';
import { EMPTY_ARRAY } from '@/redux/selectors/pieveSelectors/constants.js';
import getCompanyScopedArray from '@/redux/selectors/lib/getCompanyScopedArray.js';
import { activeCompanyId as selectedActiveCompanyId } from '@/redux/selectors/userSelectors.js';

export const automationScheduleItems = createSelector([(state) => state?.pieve?.scheduleItems || EMPTY_ARRAY, (state) => state?.pieve?.scheduleItemsScopeCompanyId || null, selectedActiveCompanyId], (scheduleItems, ownerCompanyId, activeCompanyId) => {
  return getCompanyScopedArray({
    items: scheduleItems,
    ownerCompanyId,
    activeCompanyId
  });
});

export const automationTriggerItems = createSelector([(state) => state?.pieve?.triggerItems || EMPTY_ARRAY, (state) => state?.pieve?.triggerItemsScopeCompanyId || null, selectedActiveCompanyId], (triggerItems, ownerCompanyId, activeCompanyId) => {
  return getCompanyScopedArray({
    items: triggerItems,
    ownerCompanyId,
    activeCompanyId
  });
});

export const automationTriggerItemByRequestedId = (state, requestedId) => {
  const normalizedRequestedId = String(requestedId || '').trim();

  if (!normalizedRequestedId) {
    return null;
  }

  return automationTriggerItems(state).find((trigger) => trigger?.id === normalizedRequestedId) || null;
};

export const automationScheduleItemByRequestedId = (state, requestedId) => {
  const normalizedRequestedId = String(requestedId || '').trim();

  if (!normalizedRequestedId) {
    return null;
  }

  return automationScheduleItems(state).find((schedule) => schedule?.id === normalizedRequestedId) || null;
};

export const scheduleRunDailyCounts = (state) => state?.pieve?.scheduleRunDailyCounts || EMPTY_ARRAY;
export const triggerRunDailyCounts = (state) => state?.pieve?.triggerRunDailyCounts || EMPTY_ARRAY;
export const scheduleRecentActivityChartDailyCounts = (state) => state?.pieve?.scheduleRecentActivityChartDailyCounts || EMPTY_ARRAY;
export const triggerRecentActivityChartDailyCounts = (state) => state?.pieve?.triggerRecentActivityChartDailyCounts || EMPTY_ARRAY;

export const triggerPollEvents = (state) => state?.pieve?.triggerPollEvents || EMPTY_ARRAY;
